import { render } from "./SPH.vue?vue&type=template&id=6098536f"
import script from "./SPH.vue?vue&type=script&lang=js"
export * from "./SPH.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__